import { Route } from 'vue-router'
import { isRouteAuthorized } from '@invivodf/front-seller-auth/src/isRouteAuthorized'
import { REQUESTED_RETAIL_SCOPES } from '@invivodf/front-seller-auth/src/REQUESTED_RETAIL_SCOPES'
import { IRouterURL } from '@/retail/application/types/config/router'
import { useAuthentication } from '@/retail/contexts/user/application/composables/useAuthentication'

export async function retailRouterBeforeEach(to: Route, from: Route, next) {
  if (to.meta?.allowAnonymousAccess) return next()
  if (to.path === IRouterURL.NOT_AUTHORIZED) return next()

  const { isUserAuthenticated, login, getUserScopes } = useAuthentication()
  const isAuthenticated = await isUserAuthenticated()

  if (!isAuthenticated) {
    const redirectUriAfterLogin = (to?.fullPath || '/') as string

    await login({
      appState: {
        redirectUriAfterLogin,
      },
    })
    return false
  }

  const userScopes = await getUserScopes()

  if (!REQUESTED_RETAIL_SCOPES.some((scope) => userScopes.includes(scope))) {
    return next({ path: IRouterURL.NOT_AUTHORIZED })
  }

  const isAuthorized = await isRouteAuthorized(to)
  if (isAuthorized) return next()

  return next({ path: IRouterURL.NOT_AUTHORIZED })
}
